import { createStore } from "vuex" 

const store = createStore({
   state:{
      name: "My Vue",
      currentMenu: null,
      sideMenu: true,
      fixMenu: false, 
      maxRecs: null,
      imageSize: null,
      hoverMagnify: null,
      hoverSymbols: null,
      clickAction: null,
      // ui_personalise: {
      //    max_recs: null,
      //    image_size: null,
      //    lightbox_menu: null,
      //    hover_magnify: null,
      //    hover_symbols: null,
      //    click_action: null,
      // },
   }
})

export default store